import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";
import graphqlClient from "@/GQLClient";
import { type InstitutionsEmployeeOnly } from "@/graphql";
import {
  SaveEmployeeDocument,
  GetInstitutionsEmployeesDocument,
  type EmployeeInput,
} from "@/graphql/generated-types";
import { useAuthStore } from "@/stores/authStore";

const getEmployees = async (): Promise<InstitutionsEmployeeOnly[]> => {
  const authStore = useAuthStore();
  const response = await graphqlClient.query({
    query: GetInstitutionsEmployeesDocument,
  });

  if (response.data.institutions?.getMyInstitution.employees) {
    const employees =
      response.data.institutions.getMyInstitution.employees.edges
        .map((edge) => edge.node)
        .filter(
          (node): node is InstitutionsEmployeeOnly =>
            node.__typename === "Employee",
        )
        .toSorted((a, b) => {
          const aValue = a.displayName || a.name || a.surname || "";
          const bValue = b.displayName || b.name || b.surname || "";
          return aValue.localeCompare(bValue, authStore.institutionLocale);
        });

    return employees;
  }

  throw new SentryGraphQLError("employees.getEmployees");
};

const save = async (employee: EmployeeInput) => {
  const authStore = useAuthStore();
  employee.institution = authStore.institutionId;

  const response = await graphqlClient.mutate({
    mutation: SaveEmployeeDocument,
    variables: {
      employee,
    },
  });

  if (response.data?.user?.saveProfile?.success) {
    return response;
  }

  throw new SentryGraphQLError("employees.save");
};

export default {
  getEmployees,
  save,
};
